var gql = require("@apollo/client").gql;
const MOBILE_TAGS_QUERY = gql`
	query MobileTags($region_url: String, $provider_url: String, $tag_type: String) {
		mobileTags(region_url: $region_url, provider_url: $provider_url, tag_type: $tag_type) {
			data {
				description
				name
				translit
			}
		}
	}
`;

export default MOBILE_TAGS_QUERY;
